import { AdminBlockAttributeInputType, AdminBlockTypeAttribute } from '@headlines/types/block/adminBlockType';

const embedName: AdminBlockTypeAttribute = {
  label: 'Embed placeholder title',
  key: 'embedName',
  inputType: AdminBlockAttributeInputType.STRING_INPUT,
};

export default embedName;
